// components/Amenities.js
import React, { useState } from 'react';
import './Amenities.css';
import Modal from './Modal';

const amenitiesData = {
  Bathroom: { icon: 'fas fa-bath', items: ['Bathtub', 'Cleaning products', 'Hot water'] },
  'Bedroom and laundry': { icon: 'fas fa-bed', items: ['Dryer', 'Essentials (Towels, bed sheets, soap, and toilet paper)', 'Hangers', 'Bed linens', 'Extra pillows and blankets', 'Iron', 'Safe', 'Mosquito net', 'Clothing storage'] },
  Entertainment: { icon: 'fas fa-tv', items: ['Ethernet connection', 'TV', 'Sound system', 'Books and reading material'] },
  Family: { icon: 'fas fa-baby-carriage', items: ['Window guards', 'Board games', 'Outdoor playground'] },
  'Heating and cooling': { icon: 'fas fa-snowflake', items: ['Air conditioning', 'Ceiling fan', 'Portable fans', 'Heating'] },
  'Privacy and safety': { icon: 'fas fa-shield-alt', items: ['Lock on bedroom door', 'Smoke alarm', 'Fire extinguisher', 'First aid kit'] },
  'Internet and office': { icon: 'fas fa-wifi', items: ['Wifi', 'Dedicated workspace'] },
  'Kitchen and dining': { icon: 'fas fa-utensils', items: ['Kitchen', 'Refrigerator', 'Microwave', 'Cooking basics (Pots and pans, oil, salt and pepper)', 'Dishes and silverware', 'Freezer', 'Dishwasher', 'Oven', 'Hot water kettle', 'Wine glasses', 'Toaster', 'Blender', 'Trash compactor', 'Dining table'] },
  'Location features': { icon: 'fas fa-map-marker-alt', items: ['Laundromat nearby'] },
  'Parking and facilities': { icon: 'fas fa-parking', items: ['Free parking on premises', 'Private living room'] },
  Services: { icon: 'fas fa-concierge-bell', items: ['Self check-in', 'Building staff'] },
  //'Not included': { icon: 'fas fa-times-circle', items: { 'Unavailable': ['Exterior security cameras on property', 'Washer', 'Carbon monoxide alarm'] } },
};

function Amenities() {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <section id="amenities" className="amenities-section">
      <h2 className="reveal">What this place offers</h2>
      <div className="amenities-grid reveal">
        {Object.entries(amenitiesData).map(([category, data]) => (
          <div key={category} className="amenity-category">
            <h3><i className={data.icon}></i> {category}</h3>
            <ul>
              {Array.isArray(data.items) ? (
                data.items.slice(0, 3).map((item, index) => <li key={index}>{item}</li>) // Show only first 3 items
              ) : (
                Object.entries(data.items).map(([subCategory, subItems]) => (
                  <li key={subCategory}>
                    <strong>{subCategory}</strong>
                    <ul>
                      {subItems.slice(0, 3).map((item, index) => <li key={index}>{item}</li>)}
                    </ul>
                  </li>
                ))
              )}
            </ul>
          </div>
        ))}
      </div>
      <button className="btn-primary" onClick={handleOpenModal}>View All Amenities</button>

      <Modal show={showModal} onClose={handleCloseModal}>
        <h2 className="reveal">What this place offers</h2>
        <div className="amenities-grid reveal">
          {Object.entries(amenitiesData).map(([category, data]) => (
            <div key={category} className="amenity-category">
              <h3><i className={data.icon}></i> {category}</h3>
              <ul>
                {Array.isArray(data.items) ? (
                  data.items.map((item, index) => <li key={index}>{item}</li>)
                ) : (
                  Object.entries(data.items).map(([subCategory, subItems]) => (
                    <li key={subCategory}>
                      <strong>{subCategory}</strong>
                      <ul>
                        {subItems.map((item, index) => <li key={index}>{item}</li>)}
                      </ul>
                    </li>
                  ))
                )}
              </ul>
            </div>
          ))}
        </div>
      </Modal>
    </section>
  );
}

export default Amenities;
